import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Legacy deep link `/ferias/:id` → list with that edition expanded in the tree.
 */
const FeriaEdicionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!id) {
      navigate("/ferias", { replace: true });
      return;
    }
    navigate("/ferias", {
      replace: true,
      state: { expandEdicionId: id },
    });
  }, [id, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        minHeight: 200,
        p: 3,
      }}
    >
      <CircularProgress size={22} />
      <Typography color="text.secondary">{t("FeriasPage.loading")}</Typography>
    </Box>
  );
};

export default FeriaEdicionPage;
